import { render } from "./MainInformationCard.vue?vue&type=template&id=e49edea4"
import script from "./MainInformationCard.vue?vue&type=script&lang=js"
export * from "./MainInformationCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__